import React from 'react';
import PropTypes from 'prop-types';

// The three pulsing dots that show a photo is being uploaded or prepared.
// Decorative: whoever shows them says what's happening in words.
const UploadingDots = ({ className = '', dotClassName = 'tw-w-1 tw-h-1' }) => (
  <div
    aria-hidden="true"
    className={`tw-flex tw-gap-2 tw-items-center tw-justify-center ${className}`}>
    {[1, 2, 3].map((i) => (
      <div
        key={i}
        className={`${dotClassName} tw-rounded-full tw-animate-pulse tw-bg-current`}
      />
    ))}
  </div>
);

UploadingDots.propTypes = {
  className: PropTypes.string,
  dotClassName: PropTypes.string,
};

export default React.memo(UploadingDots);
